__turbopack_context__.v({
  "chat": "Z1VPEG_chat",
  "container": "Z1VPEG_container",
  "wrapper": "Z1VPEG_wrapper",
});
